import React from "react";
import "./testimonial.css";
import Testi1 from "../components/images/testi1.png";
import Testi2 from "../components/images/testi2.webp";
import Testi3 from "../components/images/testi3.jpg";


function Testimonial() {
  return (
    <section className="testimonial-slider-section">
  <h2 className="testimonial-title">What Our Sellers Say</h2>
  <p className="testimonial-subtitle">
    Trusted by verified Amazon sellers across India
  </p>

  <div className="testimonial-slider">
    <div className="testimonial-track">

      {/* === SET 1 === */}
      <div className="testimonial-card">
        <img src={Testi1} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Policy-based work, no fake promises. Very professional team.”</p>
        <h6>SSP Hing</h6>
        <small>Karnataka</small>
      </div>

      <div className="testimonial-card">
        <img src={Testi2} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Account health and listings improved within weeks.”</p>
        <h6>CriksBites</h6>
        <small>Jharkhand</small>
      </div>

      <div className="testimonial-card">
        <img src={Testi3} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Dedicated account manager and transparent communication.”</p>
        <h6>Sajiva</h6>
        <small>Gujarat</small>
      </div>

    

      {/* === SET 2 (Exact Duplicate for Loop) === */}
      <div className="testimonial-card">
         <img src={Testi1} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Policy-based work, no fake promises. Very professional team.”</p>
        <h6>SSP Hing</h6>
        <small>Karnataka</small>
      </div>

      <div className="testimonial-card">
        <img src={Testi2} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Account health and listings improved within weeks.”</p>
        <h6>CriksBites</h6>
        <small>Jharkhand</small>
      </div>

      <div className="testimonial-card">
         <img src={Testi3} alt="Seller" />
        <span className="verified-badge">✔ Verified Amazon Seller</span>
        <p>“Dedicated account manager and transparent communication.”</p>
        <h6>Sajiva</h6>
        <small>Gujarat</small>
      </div>

     

    </div>
  </div>
</section>
  );
}

export default Testimonial;

 